module.exports = __webpack_public_path__ + "img/multiple-actions-remove.8dcf37bd.svg";